import { render, staticRenderFns } from "./prizeCard.vue?vue&type=template&id=6640ca59&scoped=true&"
import script from "./prizeCard.vue?vue&type=script&lang=js&"
export * from "./prizeCard.vue?vue&type=script&lang=js&"
import style0 from "./prizeCard.vue?vue&type=style&index=0&id=6640ca59&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6640ca59",
  null
  
)

export default component.exports